import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
  FormControlLabel,
  IconButton,
  Stack,
  Switch,
  Typography
} from '@mui/material';
import React from 'react';
import {SearchableState} from '../../../../state/searchable-state';
import {DateFilter} from '../../shared/DateFilter';
import {SupportTicketMultiSelectFilter} from '../../ticket/components/SupportTicketMultiSelectFilter';

type Props = {
  viewMode: 'CALENDAR' | 'LIST';
  onViewModeChanged: () => void;
  onAddPressed: () => void;
  searchText: string | null
  onSearchText: (value: string) => void

  searchableState: SearchableState;
  extractAvailableValues: (column: string) => string[];
  translate: (key: string) => string
}

export const SupportTaskHeader = ({
                                    onAddPressed,
                                    viewMode,
                                    onViewModeChanged,
                                    searchableState,
                                    extractAvailableValues,
                                    translate,
                                  }: Props) => {


  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
      sx={{mb: 2, pb: 1}}
    >
      {/* Lewa część: switch + filtr */}
      <Stack direction="row"
             spacing={2}
             alignItems="center"
      >
        <FormControlLabel
          labelPlacement="start"
          control={
            <Switch
              checked={viewMode === 'LIST'}
              onChange={onViewModeChanged}
              sx={{ml: 1}}
            />
          }
          label={
            <Typography fontSize={14}
                        fontWeight={500}
            >
              {viewMode === 'CALENDAR' ? 'Widok: Kalendarz' : 'Widok: Lista'}
            </Typography>
          }
          sx={{m: 0, '.MuiFormControlLabel-label': {ml: 1}}}
        />

        <SupportTicketMultiSelectFilter
          label={'Typ zadania'}
          column="support_plan_task.task_type"
          searchableState={searchableState}
          options={extractAvailableValues('support_plan_task.task_type').map((it) => ({
            label: translate(`support.plan.task.type.${it}`),
            value: it,
          }))}
        />
        {
          viewMode === 'LIST'
            ? <DateFilter
              date={searchableState.getFilterValues('support_plan_task.start_date', "GREATER_OR_EQUAL")[0] ?? null}
              onDateChange={(date) => {
                searchableState.onFilters({
                  column: 'support_plan_task.start_date',
                  searchOperator: 'GREATER_OR_EQUAL',
                  values: date === '' ? [] : [date]
                })
              }}
              label="Data rozpoczecia od"
            /> : <></>
        }
        {
          viewMode === 'LIST'
            ? <DateFilter
              date={searchableState.getFilterValues('support_plan_task.end_date', "LESSER_OR_EQUAL")[0] ?? null}
              onDateChange={(date) => {
                searchableState.onFilters({
                  column: 'support_plan_task.end_date',
                  searchOperator: 'LESSER_OR_EQUAL',
                  values: date === '' ? [] : [date]
                })
              }}
              label="Data zakonczenia do"
            /> : <></>
        }

        {/*<DateFilter*/}
        {/*  date={endDate}*/}
        {/*  onDateChange={setEndDate}*/}
        {/*  label="Zadanie do"*/}
        {/*/>*/}
      </Stack>

      {/* Prawa część: przycisk dodawania */}
      <IconButton
        aria-label="add"
        size="medium"
        sx={{borderRadius: 2, '&:hover': {backgroundColor: 'action.hover'}}}
        onClick={onAddPressed}
      >
        <AddCircleOutlineIcon fontSize="medium" />
      </IconButton>
    </Stack>
  );
};
